/**
 * Strip SOAP note section headers (<S>, <O>, <A/P>, <A>, <P> and their closing
 * tags) so they don't render as visible text or get interpreted as HTML tags.
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const stripSoapHeaders = (text) => {
  if (!text) return text
  return text
    .replace(/<S>/g, '')
    .replace(/<O>/g, '')
    .replace(/<A\/P>/g, '')
    .replace(/<A>/g, '')
    .replace(/<P>/g, '')
    .replace(/<\/S>/g, '')
    .replace(/<\/O>/g, '')
    .replace(/<\/A>/g, '')
    .replace(/<\/P>/g, '')
    .replace(/&lt;S&gt;/g, '')
    .replace(/&lt;O&gt;/g, '')
    .replace(/&lt;A\/P&gt;/g, '')
    .replace(/&lt;A&gt;/g, '')
    .replace(/&lt;P&gt;/g, '')
    .replace(/&lt;\/S&gt;/g, '')
    .replace(/&lt;\/O&gt;/g, '')
    .replace(/&lt;\/A&gt;/g, '')
    .replace(/&lt;\/P&gt;/g, '')
}

/**
 * Detect whether a note was saved as rich-text HTML (from the Quill editor)
 * or as plain text (legacy notes). Plain-text notes may contain SOAP headers
 * like <S>, <O>, <A/P> which browsers would interpret as HTML tags.
 *
 * - Rich-text: strip SOAP headers only (Quill already produces safe HTML).
 * - Plain-text: HTML-escape the entire string, then strip SOAP headers.
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const sanitizeNoteHtml = (html) => {
  if (!html) return html
  const isRichText = /<(p|div|br|h[1-6]|ul|ol|li|blockquote|pre)\b/i.test(html)
  if (isRichText) return stripSoapHeaders(html)
  const escaped = html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return stripSoapHeaders(escaped)
}
